import { GoalDeadlineRowsMap, ID } from '@griply/types';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GoalContextMenu } from 'shared/components/connected/goal-context-menu';
import { GoalRow } from 'shared/components/ui/goal-row';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';
import { Paths } from 'shared/routes/paths';
import { replaceUrlParams } from 'shared/utils/replace-url-params';

export type TreeGoalRowProps = {
  sourceId: ID;
  data: GoalDeadlineRowsMap;
};

export const TreeGoalRow: React.FC<TreeGoalRowProps> = ({ sourceId, data }) => {
  const navigate = useNavigate();
  const {
    open: openMenu,
    close: closeMenu,
    position: menuPosition,
  } = useContextMenuState();

  const row = data.get(sourceId);

  if (!row) {
    return null;
  }

  const { goal, completionPercentage, color } = row;

  const handleClick = () =>
    navigate(replaceUrlParams(Paths.GoalDetail, { id: goal.id }));

  return (
    <>
      <GoalRow
        name={goal.name}
        deadline={goal.deadline}
        completionPercentage={completionPercentage}
        color={color}
        completed={!!goal.completedAt}
        selected={!!menuPosition}
        onClick={handleClick}
        onContextMenu={openMenu}
      />

      {!!menuPosition && (
        <GoalContextMenu
          id={goal.id}
          location={menuPosition}
          onClose={closeMenu}
        />
      )}
    </>
  );
};
